<template>
    <div class="layout">
        <el-container class="layout-container">
            <!-- <div :class="[sidebarOpen ? 'drawer-bg' : '']" @click="sidebarOpen = false"></div> -->
            <span class="drawer-bg" @click="sidebarOpen = false" v-if="sidebarOpen"></span>
            <!-- Sidebar -->
            <el-aside class="sidebar-nav" :class="[sidebarOpen ? 'openSidebar' : 'hideSidebar']">
                <el-menu 
                    :default-active="$route.meta.activeNum"
                    class="el-menu-vertical-demo"
                    active-text-color="#ffd04b"
                    background-color="#fff"
                    text-color="#000"
                    @select="handleClick"
                >
                    <el-card shadow="hover">
                        <img src="@/assets/logo.png" alt="" class="logo-img">
                        Control Panel
                    </el-card>

                    <!-- <router-link to="/admin/dashboard">
                        <el-menu-item index="1">
                            <i class="el-icon-menu"></i>
                            <span slot="title">Dashboard</span>
                        </el-menu-item>
                    </router-link> -->

                    <router-link to="/admin/banner-images">
                        <el-menu-item index="9">
                            <i class="el-icon-menu"></i>
                            <span slot="title">Banner Images</span>
                        </el-menu-item>
                    </router-link>  

                    <router-link to="/admin/about" v-if="rights.about">
                        <el-menu-item index="5">
                            <i class="el-icon-menu"></i>
                            <span slot="title">About</span>
                        </el-menu-item>
                    </router-link>

                    <router-link to="/admin/testimonial" v-if="rights.testimonial">
                        <el-menu-item index="3">
                            <i class="el-icon-menu"></i>
                            <span slot="title">Testimonial</span>
                        </el-menu-item>
                    </router-link>

                    <router-link to="/admin/online-application" v-if="rights.online_application">
                        <el-menu-item index="2">
                            <i class="el-icon-menu"></i>
                            <span slot="title">Online Application</span>
                        </el-menu-item>
                    </router-link>

                    <router-link to="/admin/website-info" v-if="rights.website_info">
                        <el-menu-item index="4">
                            <i class="el-icon-menu"></i>
                            <span slot="title">Website Info</span>
                        </el-menu-item>
                    </router-link>

                    <router-link to="/admin/course" v-if="rights.course">
                        <el-menu-item index="7">
                            <i class="el-icon-menu"></i>
                            <span slot="title">Course</span>
                        </el-menu-item>
                    </router-link>

                    <router-link to="/admin/special-program" v-if="rights.special_program">
                        <el-menu-item index="11">
                            <i class="el-icon-menu"></i>
                            <span slot="title">Special Program</span>
                        </el-menu-item>
                    </router-link>

                    <router-link to="/admin/events" v-if="rights.event">
                        <el-menu-item index="8">
                            <i class="el-icon-menu"></i>
                            <span slot="title">Event</span>
                        </el-menu-item>
                    </router-link>

                    <router-link to="/admin/user-role" v-if="rights.user_role">
                        <el-menu-item index="6-1">
                            <i class="el-icon-menu"></i>
                            <span slot="title">User Role</span>
                        </el-menu-item>
                    </router-link>

                    <router-link to="/admin/permission" v-if="rights.user_rights">
                        <el-menu-item index="6-2">
                            <i class="el-icon-menu"></i>
                            <span slot="title">User Permission</span>
                        </el-menu-item>
                    </router-link>

                    <router-link to="/admin/users" v-if="rights.user">
                        <el-menu-item index="6-3">
                            <i class="el-icon-menu"></i>
                            <span slot="title">User</span>
                        </el-menu-item>
                    </router-link>                    
                    
                </el-menu>
            </el-aside>

            <!-- Header & Main -->
            <el-container class="main-layout" :class="[sidebarOpen ? 'main-position-fixed' : '']">
                <!-- Header -->
                <el-header
                    class="el-header-top" 
                    mode="horizontal" 
                    
                    >
                    <el-row>
                        <el-col :span="12" class="top-left">
                            <div class="grid-content">
                                <i class="el-icon-s-unfold sidebarOpenIcon" @click="sidebarOpen = true"></i>
                                {{$route.meta.title}}
                            </div>
                            
                        </el-col>
                        <el-col :span="12" class="top-right">
                            <div class="grid-content">
                                <el-dropdown @command="handleTopDropdown">
                                    <span class="el-dropdown-link">
                                        <i class="el-icon-s-custom"></i>
                                        {{name}}
                                        <i class="el-icon-arrow-down el-icon--right"></i>
                                    </span>
                                    <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="password"><i class="el-icon-lock"></i> Change Password</el-dropdown-item>
                                    <el-dropdown-item command="logout"><i class="el-icon-switch-button"></i> Logout</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </el-col>
                    </el-row>
                </el-header>

                <el-main>
                    <router-view/>
                </el-main>
            </el-container>

        </el-container>
    </div>
</template>

<script>
import {generateHeader} from "@/misc/function.js";
export default {
    data() {
        return {
            sidebarOpen: false,
            name: "",
            rights: {
                about: false,
                testimonial: false,
                online_application: false,
                website_info: false,
                course: false,
                events: false,
                user: false,
                user_role: false,
                user_rights: false
            }
        };
    },
    methods: {
        init(){
            this.name = localStorage.getItem('name')
            this.getRights()
        },
            getRights() {
                this.loading = true
                this.$axios.post('base/rights.php' , {} , {
                    headers: generateHeader("navRights")
                })
                .then((response) => {
                    if(response.data.code == "200"){

                        this.rights.about = response.data.body.rights.about_page == 1 ? true : false
                        this.rights.testimonial = response.data.body.rights.testimonial_page == 1 ? true : false
                        this.rights.online_application = response.data.body.rights.online_application_page == 1 ? true : false

                        this.rights.course = response.data.body.rights.course_page == 1 ? true : false
                        this.rights.special_program = response.data.body.rights.special_program_page == 1 ? true : false
                        this.rights.event = response.data.body.rights.event_page == 1 ? true : false
                        this.rights.website_info = response.data.body.rights.website_info_page == 1 ? true : false
                        this.rights.user = response.data.body.rights.user_page == 1 ? true : false
                        this.rights.user_role = response.data.body.rights.user_role_page == 1 ? true : false
                        this.rights.user_rights = response.data.body.rights.user_rights_page == 1 ? true : false

                    }
                    else if(response.data.code == "403"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        this.$router.push('/admin/dashboard')
                    }
                    else if (response.data.code == "401"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                    else{
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                    }
                    this.loading = false
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                    this.loading = false
                })
            },
        checkLogin() {
            if(localStorage.getItem("token")){
                this.$axios.post("auth/checkLogin.php" , {
                },
                {
                    headers: generateHeader("loginCheck")
                })
                .then((response) => {
                    if(!response.data.code == "200"){
                        this.$notify.info({
                            title: 'Info',
                            message: response.data.extra.message
                        });
                        localStorage.clear()
                        this.$router.push('/login')
                    }
                })
                .catch((error) => {
                    this.$notify.error({
                        title: 'Error',
                        message: error
                    });
                })
            }
        },
        handleTopDropdown(command){
            if(command === "logout"){
                this.logout()
            }
            else if(command === "profile"){
                console.log("Profile Click")
            }
            else if(command === "password"){
                this.$router.push('/admin/changePassword')
            }
        },
        logout(){
            this.$axios.post("auth/logout.php", {
            },
            {
                headers: generateHeader("logout")
            })
            .then((response) => {
                if(response.data.code == "200"){
                    localStorage.clear()
                    this.$router.push('/login')
                }
                else{
                    this.$notify.info({
                        title: 'Info',
                        message: response.data.extra.message
                    });
                }
            })
            .catch((error) => {
                this.$notify.error({
                    title: 'Error',
                    message: error
                });
            }) 
        },
        handleClick(){
            this.sidebarOpen = false
        }
    },
    mounted() {
        // this.checkLogin()
        this.init()
    }
}
</script>

<style lang="scss" scoped>
    .layout-container{
        min-height: 100vh;
        width: 100%;
    }
    .sidebar-nav{
        -webkit-transition: width 0.28s;
        transition: width 0.28s;
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        z-index: 1001;
        width: 0px !important;
    }
    .openSidebar{
        width: 250px !important;
    }
    // .hideSidebar{
    //     width: 0px !important;
    // }
    .sidebar-nav .el-menu-vertical-demo{
        height: 100%;
    }
    .el-menu{
        border-right: 0px !important;
    }
    .main-layout{
        width: 100%;
        padding: 0;
        margin: 0;
    }
    .top-right{
        text-align: right;
    }
    .top-left{
        text-align: left;
    }
    .el-header-top{
        width: 100%;
        background-color:#fff;
        color:#2d3a4b;
        font-size: 18px;
        padding-top: 20px;
        padding-right: 30px;
        box-shadow: 0 1px 4px rgba(0,21,41,0.08);
    }
    .el-icon-setting{
        font-size: 18px;
        color: #2d3a4b;
        margin-right: 10px;
    }
    .icon-style{
        color: white;
        font-size: 18px;
    }
    .sidebarOpenIcon{
        cursor: pointer;
    }
    .logo-img{
        width: 40px;
    }
    .el-card {
        border: 1px solid #fff;
        color: #000;
        transition: .3s;
    }
    .grid-content {
        min-height: 36px;
    }

    .drawer-bg {
        background: #000;
        opacity: 0.3;
        width: 100%;
        top: 0;
        height: 100%;
        position: absolute;
        z-index: 999;
    }
    .main-position-fixed{
        position: fixed;
    }
    .el-main{
        background-color: #EFF1F4;
        width: 100%;
        height: 100%;
    }
</style>